// Composite values (e.g. portfolio groups whose `value` is an array of account
// IDs) need content-based equality; arrays are reference-compared as Map keys.
function keyOf (value) {
  return JSON.stringify(value)
}

export function getRestoredSurvivors (options, candidates) {
  if (!candidates || candidates.length === 0) return []
  if (!options || options.length === 0) return []
  const byValue = new Map(options.map((opt) => [keyOf(opt.value), opt]))
  const survivors = []
  for (const candidate of candidates) {
    if (!candidate || candidate.value === undefined) continue
    const live = byValue.get(keyOf(candidate.value))
    if (live) survivors.push({ value: live.value, label: live.label })
  }
  return survivors
}
